import { render, staticRenderFns } from "./switch-input.vue?vue&type=template&id=edda4726&scoped=true&"
import script from "./switch-input.vue?vue&type=script&lang=js&"
export * from "./switch-input.vue?vue&type=script&lang=js&"
import style0 from "./switch-input.vue?vue&type=style&index=0&id=edda4726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edda4726",
  null
  
)

export default component.exports